(() => {
  function starten(huelle) {
    if (huelle.dataset.gzBereit) return;
    huelle.dataset.gzBereit = '1';
    const T = JSON.parse(huelle.querySelector('[data-gz-texte]').textContent);
    const api = huelle.dataset.api;
    const wurzel = huelle.dataset.wurzel || '';
    const sprache = huelle.dataset.sprache || 'de';
    const ansicht = huelle.dataset.ansicht || 'adresse';
    const kompakt = ansicht !== 'adresse';
    const ziel = huelle.querySelector('[data-gz-ziel]');
    const einw = huelle.querySelector('[data-gz-einw]');
    const q = new URLSearchParams(location.search);

    let pfad = '';
    if (ansicht === 'registrieren') pfad = '/registrieren';
    else if (ansicht === 'adresse') {
      pfad = q.get('z') ? '/z/' + encodeURIComponent(q.get('z'))
        : q.has('registrieren') ? '/registrieren' : '';
    }

    function fehler(el, text) {
      if (!el) return;
      el.textContent = text;
      el.hidden = false;
    }

    function einsetzen(html) {
      ziel.innerHTML = html;
      if (wurzel) {
        ziel.querySelectorAll('a[href^="/"]').forEach((a) => {
          a.setAttribute('href', wurzel + a.getAttribute('href'));
        });
      }
      const mit = ziel.querySelector('[data-gz-email]');
      const platz = ziel.querySelector('[data-gz-einw-platz]');
      if (einw && mit && platz) {
        const feld = einw.querySelector('[data-gz-mail]');
        if (feld) feld.value = mit.dataset.gzEmail;
        platz.replaceWith(einw);
        einw.hidden = false;
      }
      ziel.querySelectorAll('[data-gz-drucken]').forEach((a) => a.addEventListener('click', (e) => {
        e.preventDefault();
        window.print();
      }));
      ziel.querySelectorAll('form[data-gz-form]').forEach(formular);
    }

    function formular(f) {
      f.addEventListener('submit', async (e) => {
        e.preventDefault();
        const meldung = f.querySelector('[data-gz-fehler]');
        if (!f.checkValidity()) {
          f.reportValidity();
          return;
        }
        const knopf = f.querySelector('button[type="submit"]');
        const knopfText = knopf.textContent;
        knopf.disabled = true;
        knopf.textContent = T.senden;
        const daten = new FormData(f);
        daten.append('sprache', sprache);
        if (kompakt) daten.append('kompakt', '1');
        try {
          const r = await fetch(api + '/' + f.dataset.gzForm, {
            method: 'POST', body: daten, headers: { Accept: 'application/json' },
          });
          const d = await r.json();
          if (d.weiter) {
            location.href = huelle.dataset.seite + '?z=' + encodeURIComponent(d.weiter);
            return;
          }
          if (d.html) {
            einsetzen(d.html);
            huelle.scrollIntoView({ block: 'start' });
            return;
          }
          fehler(meldung, d.fehler || T.senden_fehler);
        } catch (_) {
          fehler(meldung, T.senden_fehler);
        }
        knopf.disabled = false;
        knopf.textContent = knopfText;
        if (meldung && !meldung.hidden) meldung.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }

    const einwForm = einw && einw.querySelector('form');
    if (einwForm && einwForm.querySelector('[data-gz-mail]')) {
      einwForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!einwForm.checkValidity()) {
          einwForm.reportValidity();
          return;
        }
        const knopf = einwForm.querySelector('button[type="submit"]');
        knopf.disabled = true;
        try {
          const r = await fetch(einwForm.action, { method: 'POST', body: new FormData(einwForm) });
          if (!r.ok || r.url.includes('/challenge')) throw new Error('weiter');
          einwForm.innerHTML = einw.querySelector('template[data-gz-danke]').innerHTML;
        } catch (_) {
          einwForm.submit();
        }
      });
    }

    const abfrage = '?teil=1&sprache=' + encodeURIComponent(sprache) + (kompakt ? '&kompakt=1' : '');
    fetch(api + pfad + abfrage, { headers: { Accept: 'text/html' } })
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      })
      .then(einsetzen)
      .catch(() => {
        ziel.innerHTML = '';
        const p = document.createElement('p');
        p.className = 'gz__fehler';
        p.textContent = T.laden_fehler;
        ziel.appendChild(p);
      });
  }

  document.querySelectorAll('[data-gz-huelle]').forEach(starten);
})();
